import { faCheckSquare, faFileAlt, faFrown, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faSpinner, faSync, faTruck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Badge, Col, Row } from 'reactstrap';
import ToolTip from 'src/Components/Tooltip';
import { IEngineer, IWell } from 'src/Interfaces/WellInterface';
import { IWellTestSyncError, SyncStore } from 'src/Stores/Sync/SyncStore';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { ITest } from '../../../../Interfaces/TestInterface';
import { IUser } from '../../../../Interfaces/UserInterface';
import { UserStore } from '../../../../Stores/User/UserStore';

@inject('stores')
@observer
class WorkflowNav extends React.Component {
    public props: any;
    public UserStore: UserStore;
    public userObject: IUser;
    public userObserver: any;
    public SyncStore: SyncStore;
    public TenantStore: TenantStore;

    public state = {
        isAdmin: false,
        testListExpanded: true,
        user: this.userObject,
        wellListExpanded: false,
    };

    constructor(props: any) {
        super(props);
        this.SyncStore = this.props.stores.SyncStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.newTest = this.newTest.bind(this);
        this.showTestList = this.showTestList.bind(this);
        this.clearSync = this.clearSync.bind(this);
    }

    public componentDidMount() {
        this.userObserver = observe(this.UserStore, 'user', (change: any) => {
            this.setState({
                isAdmin: this.UserStore.hasPermission('Permissions.Admin.View'),
                user: this.UserStore.getUser(),
            });
            return change;
        });
        this.setState({
            isAdmin: this.UserStore.hasPermission('Permissions.Admin.View'),
            user: this.UserStore.getUser()
        });
    }

    public componentWillUnmount() {
        this.userObserver();
    }

    public newTest() {
        const well: IWell = this.props.well;
        if (well && well.wellStatus === 'Active') {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/new/welldata/testsetup');
        }
    }

    public canCreateNewTest = () => {
        if (this.props.well && this.props.well.wellStatus !== 'Active') {
            return false;
        }
        
        if (this.UserStore.hasGenericPermission("Permissions.WellTests.Create")) {
            if (this.props.testList && this.props.testList[0] && this.props.testList[0].testStatus !== 'Approved') {
                if (this.UserStore.hasGenericPermission("Permissions.WellTests.Approve")) {
                    if (this.UserStore.hasPermission('Permissions.WellTests.Approve.All')) {
                        return true;
                    } else {
                        if (this.props.well.engineers.some((wu: IEngineer) => wu.id === this.UserStore.user.id)) {
                            return true;
                        }
                    }
                }
            } else {
                return true;
            }
        }
        return false;
    }

    private clearSync() {
        const areYouSure = confirm("Are you sure you want to DELETE ALL UNSYNCED DATA?");
        if (areYouSure) {
            this.SyncStore.clearUnsyncedData();
        }
    }

    public showWellList = () => {
        this.setState({
            wellListExpanded: !this.state.wellListExpanded,
        });
    }

    public showTestList() {
        if (this.state.testListExpanded) {
            this.setState({
                testListExpanded: false
            });
        } else {
            this.setState({
                testListExpanded: true
            });
        }
    }

    public listBold = (listValue: string | undefined, listName: string) => {
        if (this.props.match.path.includes('home') && this.props.match.params.list === listValue) {
            return <strong>{listName}</strong>;
        }
        return listName;
    }

    public render() {
        return (
            <div className="WorkflowNav">
                <h2 style={{textAlign: 'center'}}>
                    <Link to="/home">
                        <img style={{maxWidth: '100%', height: 'auto'}} src={this.TenantStore.logoPathNameApp} />
                    </Link>
                </h2>
                <h2 style={{textAlign: 'center'}}>
                    { this.props.stores.SyncStore.offline ? 
                        <Badge color="warning" >Offline</Badge> :
                        this.props.stores.syncingOffline ? 
                        <Badge color="success">
                            Downloading
                            <FontAwesomeIcon
                                icon={faSpinner}
                                spin={true}
                                style={{marginLeft: '0.1rem'}}
                            />
                        </Badge>
                        :
                        <Badge color="success" onClick={this.props.stores.getAllDataForOffline}>
                            <FontAwesomeIcon
                                icon={faSync}
                                style={{marginRight: '0.1rem'}}
                            />
                            Online
                        </Badge>
                    }
                </h2>
                <ul className="WorkflowNav-options">
                    <li>
                        {
                            this.UserStore.hasGenericPermission('Permissions.Wells.Read') &&
                            <Row>
                                <Col md={8}>
                                    <Link to="/home">
                                        <span><FontAwesomeIcon
                                                icon="list-ul"
                                                color={this.TenantStore.iconColor}
                                                size="2x"/>
                                        </span>
                                        <h5>Well List</h5>
                                    </Link>
                                </Col>
                                {/* {
                                !this.SyncStore.offline &&
                                <Col md={2} style={{padding: '0'}}>
                                    <span onClick={this.showWellList}>
                                            <FontAwesomeIcon
                                                icon="chevron-right"
                                                color={this.TenantStore.iconColor}
                                                size="2x"
                                                rotation={ this.state.wellListExpanded ?
                                                    270 : 90
                                                }
                                                transform="shrink-2"
                                                />
                                    </span>
                                </Col>
                                }    */}
                            </Row>
                        }
                        {/* {
                            this.state.wellListExpanded && !this.SyncStore.offline &&
                            <ul className="previous-tests">
                                <Link to="/home">
                                    <li>
                                        {this.listBold(undefined, 'Active')}
                                    </li>
                                </Link>
                                <Link to="/home/finishing">
                                    <li>
                                        {this.listBold('finishing', 'Finishing')}
                                    </li>
                                </Link>
                                {
                                    this.state.user && 
                                    this.UserStore.hasGenericPermission('Permissions.Wells.ReadClosed') &&
                                    <Link to="/home/closed">
                                        <li>
                                            {this.listBold('closed', 'Closed')}
                                        </li>
                                    </Link>
                                }
                            </ul>
                        } */}
                    </li>
                    {this.props.match.params.wellId &&
                        this.props.match.params.wellId !== 'new' &&
                        this.props.match.params.wellId !== null &&
                        this.SyncStore.unsyncedTests.length > 0 ?
                        <li className="tests">
                            <Row>
                                <Col md="12">
                                    <span>
                                        <FontAwesomeIcon
                                            icon={ faFrown }
                                            color={this.TenantStore.iconColor}
                                            size="2x"
                                        />
                                    </span>
                                    <h5>Sync Error Tests</h5>
                                    <span className="float-right" onClick={this.clearSync}>
                                        <ToolTip
                                            text="Clear all Unsynced Data. CANNOT BE UNDONE."
                                        >
                                            <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color={this.TenantStore.iconColor}
                                                size={"2x"}
                                                transform="shrink-3"
                                            />
                                        </ToolTip>
                                    </span>
                                </Col>
                                <Col md="12">
                                    <ul className="previous-tests">
                                        {this.SyncStore.unsyncedTests.slice().map((row: IWellTestSyncError, index: number) =>
                                        <li key={index}>
                                            <ToolTip
                                                text={row.errorMessage}
                                                key={index}
                                            >
                                                <Link to={"/well/" + row.wellId+ "/test/" + row.wellTestId + "/welldata/testsetup"} key={index}><li>{moment.unix(row.testDate).format("MMM DD YYYY, h:mm a")}</li></Link>
                                            </ToolTip>
                                        </li>
                                        )}
                                    </ul>
                                </Col>
                            </Row>
                        </li>
                        : null
                    }
                    {this.props.match.params.wellId &&
                        this.props.match.params.wellId !== 'new' &&
                        this.props.match.params.wellId !== null &&
                        this.UserStore.hasGenericPermission("Permissions.WellTests.Read") &&
                        <li className="tests">
                                    <Row>
                                        <Col>
                                    { this.props.testList && this.props.testList.length > 0 ?
                                        <Link to={ "/well/" + this.props.match.params.wellId + "/test/" + this.props.testList[0].id + "/welldata/testsetup" }>
                                            <span>
                                                <FontAwesomeIcon
                                                    icon="clipboard-check"
                                                    color={this.TenantStore.iconColor}
                                                    size="2x"
                                                    />
                                            </span>
                                            <h5>Tests</h5>
                                        </Link> :
                                        <Link to={ "/well/" + this.props.match.params.wellId + "/test/new/welldata/testsetup" }>
                                            <span>
                                                <FontAwesomeIcon
                                                    icon="clipboard-check"
                                                    color={this.TenantStore.iconColor}
                                                    size="2x"
                                                    />
                                            </span>
                                            <h5>Tests</h5>
                                        </Link>
                                    }
                                    </Col>
                                    <Col>
                                    <span onClick={this.showTestList}>
                                        <FontAwesomeIcon
                                            icon="chevron-right"
                                            color={this.TenantStore.iconColor}
                                            size="2x"
                                            rotation={ this.state.testListExpanded ?
                                                270 : 90
                                            }
                                            transform="shrink-2"
                                            />
                                    </span>
                                    {
                                        this.canCreateNewTest() &&
                                        <span onClick={this.newTest}>
                                            <FontAwesomeIcon
                                                icon="plus"
                                                color={this.TenantStore.iconColor}
                                                size={"2x"}
                                                transform="shrink-3"
                                                />
                                        </span>
                                    }
                                    </Col>
                                </Row>
                                { this.state.testListExpanded && this.props.well.id !== '' && 
                                    <ul className="previous-tests">
                                        { this.props.testList.sort((a: ITest, b: ITest) => Number(b.testDate) - Number(a.testDate)).map((test: ITest, index: number) =>
                                            <Link to={"/well/" + this.props.match.params.wellId + "/test/" + test.id + "/welldata/testsetup"} key={index}>
                                                <li>
                                                    {
                                                        this.props.match.params.taskId === test.id 
                                                            ? <strong><em>{moment.unix(test.testDate).tz(this.props.well.timeZoneName).format("MMM DD YYYY, h:mm a")}</em></strong>
                                                            : moment.unix(test.testDate).tz(this.props.well.timeZoneName).format("MMM DD YYYY, h:mm a")
                                                    }
                                                </li>
                                            </Link>
                                            ) }
                                    </ul>
                                }
                        </li>
                    }
                    {   this.state.user &&
                        this.UserStore.hasPermission('Permissions.WellTests.Approve.All') ?
                        <li >
                            <Link to={"/approvals"}>
                                <span>
                                    <FontAwesomeIcon
                                        icon={faCheckSquare}
                                        color={this.TenantStore.iconColor}
                                        size={"2x"}
                                        transform="shrink-3"
                                        />
                                </span>
                                <h5>
                                    Approvals
                                </h5>
                            </Link>
                        </li> 
                        :
                        ( this.UserStore.hasGenericPermission('Permissions.WellTests.Create')
                            || this.UserStore.hasGenericPermission('Permissions.WellTests.Update')
                        ) &&
                        <li >
                            <Link to={"/submissions"}>
                                <span>
                                    <FontAwesomeIcon
                                        icon={faCheckSquare}
                                        color={this.TenantStore.iconColor}
                                        size={"2x"}
                                        transform="shrink-3"
                                        />
                                </span>
                                <h5>
                                    Submissions
                                </h5>
                            </Link>
                        </li> 

                    }
                    <li>
                        {
                            this.UserStore.hasGenericPermission('Permissions.Dispatch.Read') && 
                            <Link to={'/dispatches'}>
                                <span>
                                    <FontAwesomeIcon
                                        icon={faTruck}
                                        color={this.TenantStore.iconColor}
                                        size={"2x"}
                                        transform="shrink-3"
                                    />
                                </span>
                                <h5>
                                    Dispatches
                                </h5>
                            </Link>
                        }
                    </li>
                    <li >
                        {
                            (this.UserStore.hasGenericPermission("Permissions.Reports.System.View")
                            || this.UserStore.hasGenericPermission("Permissions.Reports.Custom.View"))
                            &&
                            <Link to={"/reports"}>
                                <span>
                                    <FontAwesomeIcon
                                        icon={faFileAlt}
                                        color={this.TenantStore.iconColor}
                                        size={"2x"}
                                        transform="shrink-3"
                                        />
                                </span>
                                <h5>
                                    Reports
                                </h5>
                            </Link>
                        }
                    </li>
                    {this.state.user && this.state.isAdmin &&
                        <li>
                            <Link to="/admin">
                                <span>
                                    <FontAwesomeIcon
                                        icon="user-cog"
                                        color={this.TenantStore.iconColor}
                                        size="2x"
                                    />
                                </span>
                                <h5>Admin</h5>
                            </Link>
                        </li>
                    }
                </ul>
            </div>
        );
    }
}

export default withRouter(WorkflowNav);



// WEBPACK FOOTER //
// ./src/Components/Main/Sidebar/WorkflowNav/WorkflowNav.tsx